import zhHans from './zh-CN'
import en from './en'

export default {
	'zh-CN': zhHans,
	'en': en
}


// WEBPACK FOOTER //
// ./src/i18n/index.js